import { ExampleCard } from './ExampleCard';
export default ExampleCard;
